import { MutationHookOptions, useMutation } from '@apollo/client';

import { CREATE_PARENT } from './mutations';

export const useCreateParent = (options?: MutationHookOptions) => useMutation(CREATE_PARENT, options);
